import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Box, Button, Box as Container } from '@node-space/ui-components'

export interface HeaderCTAProps {
  helpText?: string
  buttonText: string
  buttonUrl: string
  externalLink?: boolean
}

export const HeaderCTA = ({ helpText, buttonText, buttonUrl, externalLink }: HeaderCTAProps) => {
  const navigate = useNavigate()

  const goInternal = () => navigate(buttonUrl)
  const goExternal = () => window.open(buttonUrl)

  const onClickHandler = () => {
    externalLink ? goExternal() : goInternal()
  }

  return (
    <Container flex align="center" justify="end" className="flex-wrap pl-4">
      {helpText && (
        <span className="text-body-regular text-foreground-subdued py-2">{helpText}</span>
      )}
      <Box className={helpText ? 'ml-3' : ''}>
        <Button onClick={onClickHandler} variant="secondary">
          {buttonText}
        </Button>
      </Box>
    </Container>
  )
}
